<template>
    <div id="accessLayout">
        <router-view />
    </div>
</template>
<script>
export default {
    name: "AccessLayout",
    mounted() {
    }
}
</script>
<style scoped>
#accessLayout {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: self-start;
    padding-top: 120px;
}
</style>
